import { Dispatch, ReactNode, SetStateAction, createContext, useContext, useState } from 'react';

type TabsContextProps = {
  currentIndex: number;
  setCurrentIndex: Dispatch<SetStateAction<number>>;
  reRender: boolean;
};
const initialContext = {
  currentIndex: 0,
  setCurrentIndex: () => {},
  reRender: true,
};

const TabsContext = createContext<TabsContextProps>(initialContext);

type TabsProviderProps = {
  reRender: boolean;
  children: ReactNode;
  defaultIndex?: number;
  value?: number;
  onChange?: (index: number) => void;
};

export default function TabsProvider({
  children,
  reRender,
  defaultIndex = 0,
  value,
  onChange,
}: TabsProviderProps) {
  const [internalIndex, setInternalIndex] = useState<number>(value !== undefined ? value : defaultIndex);

  const currentIndex = value !== undefined ? value : internalIndex;

  const setCurrentIndex: Dispatch<SetStateAction<number>> = (action) => {
    const nextIndex = typeof action === 'function' ? action(currentIndex) : action;
    if (value === undefined) {
      setInternalIndex(nextIndex);
    }
    onChange?.(nextIndex);
  };

  return (
    <TabsContext.Provider value={{ currentIndex, setCurrentIndex, reRender }}>
      {children}
    </TabsContext.Provider>
  );
}

export function useTabsContext(): TabsContextProps {
    const context = useContext(TabsContext);
    if (!context) {
        throw new Error('useTabsContext must be used within a TabsProvider');
    }
    return context;
}

